import {
  CREATE_VISIT_FAIL,
  CREATE_VISIT_REQUEST,
  CREATE_VISIT_SUCCESS,
  FETCH_VISIT_FAIL,
  FETCH_VISIT_REQUEST,
  FETCH_VISIT_SUCCESS,
} from "../../ActionType/VisitType/VisitType";
import { api } from "../../Api/api";
import { getToken } from "../login";

export const createVisitAction = (patient_id) => async (dispatch) => {
  const config = {
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
  };
  dispatch({
    type: CREATE_VISIT_REQUEST,
    payload: [],
  });

  try {
    const response = await api.post("visit/create", { patient_id }, config);

    const { status, data } = response;
    if (status == 200) {
      dispatch({
        type: CREATE_VISIT_SUCCESS,
        payload: data,
      });
    }
  } catch (error) {
    
    dispatch({
      type: CREATE_VISIT_FAIL,
      payload: [],
    });
  }
};

export const updateVisitAction = (visit_id, assign) => async (dispatch) => {
  const config = {
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
  };
  dispatch({
    type: CREATE_VISIT_REQUEST,
    payload: [],
  });

  try {
    const response = await api.put(
      "visit/update/" + visit_id,
      { assign },
      config
    );
    const { status, data } = response;
    if (status == 200) {
      dispatch({
        type: CREATE_VISIT_SUCCESS,
        payload: data,
      });
    }
  } catch (error) {
    console.log(error);
    dispatch({
      type: CREATE_VISIT_FAIL,
      payload: [],
    });
  }
};


export const updateFollowUpAssignVisitAction = (visit_id, assign) => async (dispatch) => {
  const config = {
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
  };
  
  try {
    const response = await api.put(
      "visit/updateFollowUpAssign/" + visit_id,
      { assign },
      config
    );
    const { status, data } = response;
    console.log(response)
    
  } catch (error) {
    console.log(error)
    
  }
};

export const updateRejectVisitAction =
  (visit_id, reject) => async (dispatch) => {
    const config = {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    };
    dispatch({
      type: CREATE_VISIT_REQUEST,
      payload: [],
    });

    try {
      const response = await api.put(
        "visit/updateReject/" + visit_id,
        { reject },
        config
      );
      const { status, data } = response;
      if (status == 200) {
        dispatch({
          type: CREATE_VISIT_SUCCESS,
          payload: data,
        });
      }
    } catch (error) {
      console.log(error);
      dispatch({
        type: CREATE_VISIT_FAIL,
        payload: [],
      });
    }
  };

export const getVisitAction = (patient_id) => async (dispatch) => {
  const config = {
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
    params: {
      patient_id,
    },
  };
  dispatch({
    type: FETCH_VISIT_REQUEST,
    payload: [],
  });

  try {
    const response = await api.get("visit", config);

    const { status, data } = response;
    if (status == 200) {
      dispatch({
        type: FETCH_VISIT_SUCCESS,
        payload: data,
      });
    }
  } catch (error) {
    // console.log(error);
    dispatch({
      type: FETCH_VISIT_FAIL,
      payload: [],
    });
  }
};
